import { Viewport } from "reactflow"
import { supabase } from "../database/SupabaseConnector"

export async function updateViewport(viewport: Viewport, userId: string) {


    await supabase
    .from("user_settings")
    .update({
      canvas_x: viewport.x,
      canvas_y: viewport.y,
      canvas_zoom: viewport.zoom,
    })
    .eq("user_id", userId)
}
